<template>
	<div class="book-import">
		<div class="book-import__head">
			<h1>Импорт книг</h1>
			<p>Парсинг книг с cloud.mail.ru, конвертация в PDF, генерация обложки и загрузка в Timeweb S3.</p>
		</div>

		<div class="book-import__grid">
			<div class="book-import__main">
				<label class="book-import__label">Ссылка на публичную папку cloud.mail.ru</label>
				<input
					v-model="publicUrl"
					class="el-inp book-import__input-full"
					placeholder="https://cloud.mail.ru/public/..."
					:disabled="isRunning"
				>

				<label class="book-import__label book-import__label-mt">Категория (латиницей, напр. sport, history)</label>
				<input
					v-model="category"
					class="el-inp book-import__input-full"
					placeholder="sport"
					:disabled="isRunning"
				>
				<div class="book-import__hint-small">
					Результат будет сохранён в <code>book_json/books_{{ category || '...' }}.json</code>
				</div>

				<label class="book-import__label book-import__label-mt">Обложка-заглушка (если в PDF её нет)</label>
				<select v-model="coverMode" class="el-inp book-import__input-full" :disabled="isRunning">
					<option value="template">Фиксированный шаблон + текст (быстро, бесплатно, надёжно)</option>
					<option value="ai_full">Генерировать целиком через ИИ (дороже, дольше, экспериментально)</option>
				</select>
				<div class="book-import__hint-small">
					При «через ИИ»: если модель не смогла корректно нарисовать название/автора
					(проверяется автоматически), обложка откатится на фиксированный шаблон.
				</div>

				<div class="book-import__controls">
					<button class="el-btn" :disabled="isRunning || !publicUrl || !category" @click="startParsing">
						{{ isRunning ? 'Парсинг выполняется...' : 'Начать парсинг' }}
					</button>
					<button v-if="isRunning" class="el-btn product-import__btn-secondary" @click="stopParsing">
						Остановить
					</button>
				</div>

				<div v-if="error" class="book-import__error">{{ error }}</div>

				<div class="book-import__log-wrap">
					<div class="book-import__hint-title">Лог</div>
					<pre ref="logBox" class="book-import__log">{{ log || 'Лог появится после запуска парсинга.' }}</pre>
				</div>
			</div>

			<div class="book-import__side">
				<div class="book-import__hint-title">Готовые JSON-каталоги</div>
				<div v-if="!files.length" class="book-import__empty">Пока нет ни одного файла.</div>
				<div v-for="f in files" :key="f.file" class="book-import__file-item">
					<div class="book-import__file-row">
						<a :href="f.raw_url" target="_blank">{{ f.file }}</a>
						<span class="book-import__file-count">{{ f.books_count }} книг</span>
					</div>
					<button class="book-import__link-btn" @click="toggleEdit(f)">
						{{ editingFile === f.file ? 'Скрыть' : 'Редактировать' }}
					</button>

					<div v-if="editingFile === f.file" class="book-import__editor">
						<textarea v-model="editorContent" class="book-import__editor-textarea" spellcheck="false"></textarea>
						<div class="book-import__editor-actions">
							<span v-if="editorError" class="product-import__json-error">Невалидный JSON</span>
							<button class="el-btn" :disabled="!!editorError" @click="saveFile(f)">Сохранить</button>
						</div>
					</div>
				</div>

				<div class="book-import__load-block">
					<div class="book-import__hint-title">Загрузить в БД</div>
					<input v-model="loadFileName" class="el-inp book-import__input-full" placeholder="books_sport.json">
					<button class="el-btn book-import__load-btn" @click="loadToDb">Загрузить</button>
					<div v-if="loadMessage" class="book-import__load-message">{{ loadMessage }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['url'],
		data() {
			return {
				publicUrl: '',
				category: '',
				coverMode: 'template',
				runId: null,
				isRunning: false,
				log: '',
				error: '',
				pollTimer: null,
				files: [],
				editingFile: null,
				editorContent: '',
				editorError: false,
				loadFileName: '',
				loadMessage: '',
			}
		},
		watch: {
			editorContent(val) {
				try { JSON.parse(val); this.editorError = false; }
				catch (e) { this.editorError = true; }
			}
		},
		mounted() {
			this.loadFiles();
			this.resumeIfRunning();
		},
		beforeDestroy() {
			this.stopPolling();
		},
		methods: {
			async resumeIfRunning() {
				try {
					const result = await this.$axios.get('/ext/book_import_ext/parse/lastRuns/');
					const running = (result.data.runs || []).find(r => r.running);
					if (running) {
						this.runId = running.run_id;
						this.isRunning = true;
						this.log = running.log || '';
						this.startPolling();
					}
				} catch (e) { /* тихо игнорируем */ }
			},
			async startParsing() {
				this.error = '';
				this.log = '';
				try {
					const result = await this.$axios.post('/ext/book_import_ext/parse/start/', {
						public_url: this.publicUrl,
						category: this.category,
						cover_mode: this.coverMode,
					});
					if (!result.data.success) {
						this.error = result.data.message || 'Не удалось запустить парсинг';
						return;
					}
					this.runId = result.data.run_id;
					this.isRunning = true;
					this.startPolling();
				} catch (e) {
					this.error = 'Ошибка запроса запуска';
				}
			},
			async stopParsing() {
				if (!this.runId) return;
				await this.$axios.post(`/ext/book_import_ext/parse/stop/${this.runId}/`);
			},
			startPolling() {
				this.stopPolling();
				this.pollTimer = setInterval(this.pollStatus, 3000);
				this.pollStatus();
			},
			stopPolling() {
				if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null; }
			},
			async pollStatus() {
				if (!this.runId) return;
				try {
					const result = await this.$axios.get(`/ext/book_import_ext/parse/status/${this.runId}/`);
					const data = result.data;
					this.log = data.log || '';
					this.$nextTick(() => {
						if (this.$refs.logBox) this.$refs.logBox.scrollTop = this.$refs.logBox.scrollHeight;
					});

					if (!data.running) {
						this.isRunning = false;
						this.stopPolling();
						this.loadFiles();
						if (data.state === 'error' || data.state === 'crashed') {
							this.error = (data.result && data.result.message) ? data.result.message : 'Парсинг завершился с ошибкой';
						}
					}
				} catch (e) {
					// сеть могла моргнуть — просто попробуем в следующий тик
				}
			},
			async loadFiles() {
				try {
					const result = await this.$axios.get('/ext/book_import_ext/catalog/list/');
					if (result.data.success) this.files = result.data.files;
				} catch (e) { /* игнорируем */ }
			},
			async toggleEdit(f) {
				if (this.editingFile === f.file) { this.editingFile = null; return; }
				try {
					const result = await this.$axios.get(`/ext/book_import_ext/catalog/get/${encodeURIComponent(f.file)}/`);
					if (result.data.success) {
						this.editorContent = result.data.content;
						this.editingFile = f.file;
					}
				} catch (e) {
					this.error = 'Не удалось загрузить файл для редактирования';
				}
			},
			async saveFile(f) {
				try {
					const result = await this.$axios.post(`/ext/book_import_ext/catalog/save/${encodeURIComponent(f.file)}/`, {
						content: this.editorContent,
					});
					if (result.data.success) {
						this.ElMessage('Сохранено');
						this.loadFiles();
					} else {
						this.error = result.data.message || 'Не удалось сохранить';
					}
				} catch (e) {
					this.error = 'Ошибка сохранения';
				}
			},
			async loadToDb() {
				this.loadMessage = '';
				try {
					const result = await this.$axios.post('/ext/book_import_ext/import/run/', {
						file: this.loadFileName,
					});
					this.loadMessage = result.data.message || '';
				} catch (e) {
					this.loadMessage = 'Ошибка запроса';
				}
			},
		}
	}
</script>

<style lang="scss">
	.book-import {
		max-width: 1180px;
		color: #19202a;
	}

	.book-import__head {
		margin-bottom: 24px;

		h1 { margin: 0 0 8px; font-size: 28px; font-weight: 700; }
		p { margin: 0; max-width: 760px; line-height: 1.5; color: rgba(25, 32, 42, 0.72); }
	}

	.book-import__grid {
		display: grid;
		grid-template-columns: minmax(0, 1fr) 360px;
		gap: 24px;
		align-items: start;
	}

	.book-import__main, .book-import__side {
		border: 1px solid rgba(103, 115, 135, 0.22);
		border-radius: 8px;
		background: #fff;
		padding: 18px;
	}

	.book-import__label {
		display: block;
		margin-bottom: 8px;
		font-size: 13px;
		font-weight: 600;
	}

	.book-import__label-mt { margin-top: 18px; }

	.book-import__input-full { width: 100%; box-sizing: border-box; }

	.book-import__hint-small {
		margin-top: 6px;
		font-size: 12px;
		color: rgba(25, 32, 42, 0.55);

		code { background: rgba(103, 115, 135, 0.12); padding: 1px 5px; border-radius: 3px; }
	}

	.book-import__controls {
		display: flex;
		gap: 10px;
		margin-top: 18px;
	}

	.product-import__btn-secondary {
		background: transparent;
		color: #19202a;
		border: 1px solid rgba(103, 115, 135, 0.35);

		&:hover:not(:disabled) { background: rgba(103, 115, 135, 0.08); }
	}

	.book-import__error {
		margin-top: 14px;
		padding: 12px 14px;
		border-radius: 8px;
		background: rgba(208, 18, 70, 0.1);
		color: #d01246;
		font-size: 13px;
	}

	.book-import__log-wrap { margin-top: 20px; }

	.book-import__hint-title {
		margin-bottom: 8px;
		font-size: 13px;
		font-weight: 700;
	}

	.book-import__log {
		max-height: 360px;
		overflow-y: auto;
		background: #12181f;
		color: #d7e0ea;
		border-radius: 8px;
		padding: 14px;
		font-family: 'Courier New', Courier, monospace;
		font-size: 12.5px;
		line-height: 1.5;
		white-space: pre-wrap;
		word-break: break-word;
	}

	.book-import__empty { font-size: 13px; color: rgba(25, 32, 42, 0.5); }

	.book-import__file-item {
		padding: 10px 0;
		border-bottom: 1px solid rgba(103, 115, 135, 0.15);

		&:last-of-type { border-bottom: none; }
	}

	.book-import__file-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;

		a { color: #2c6bd6; text-decoration: none; font-size: 14px; word-break: break-all; }
	}

	.book-import__file-count { font-size: 11px; color: rgba(25, 32, 42, 0.5); white-space: nowrap; }

	.book-import__link-btn {
		margin-top: 6px;
		border: none;
		background: none;
		color: #2c6bd6;
		font-size: 12px;
		cursor: pointer;
		padding: 0;

		&:hover { text-decoration: underline; }
	}

	.book-import__editor { margin-top: 10px; }

	.book-import__editor-textarea {
		width: 100%;
		min-height: 220px;
		box-sizing: border-box;
		padding: 10px;
		font-family: 'Courier New', Courier, monospace;
		font-size: 12.5px;
		border: 1px solid rgba(103, 115, 135, 0.22);
		border-radius: 6px;
		resize: vertical;
	}

	.book-import__editor-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 8px;
	}

	.product-import__json-error { font-size: 12px; color: #d01246; }

	.book-import__load-block {
		margin-top: 24px;
		padding-top: 16px;
		border-top: 1px solid rgba(103, 115, 135, 0.15);
	}

	.book-import__load-btn { margin-top: 10px; width: 100%; }

	.book-import__load-message {
		margin-top: 10px;
		font-size: 12.5px;
		color: rgba(25, 32, 42, 0.7);
	}

	@media (max-width: 900px) {
		.book-import__grid { grid-template-columns: 1fr; }
	}
</style>
